import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import SearchPage from "@/pages/SearchPage";
import TenderDetailPage from "@/pages/TenderDetailPage";
import ScraperConfigPage from "@/pages/ScraperConfigPage";
import ScraperMonitorPage from "@/pages/ScraperMonitorPage";
import UsersPage from "@/pages/UsersPage";
import ExportPage from "@/pages/ExportPage";
import AlertsPage from "@/pages/AlertsPage";
import FavoritesPage from "@/pages/FavoritesPage";
import PricingPage from "@/pages/PricingPage";
import AccountSettingsPage from "@/pages/AccountSettingsPage";
import AdminClientsPage from "@/pages/AdminClientsPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import SuppliersPage from "@/pages/SuppliersPage";

function ProtectedRoute({ children, roles }) {
  const { user, loading, mustChangePassword } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="mt-4 text-sm text-muted-foreground font-mono">Cargando...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (mustChangePassword) return <Navigate to="/cambiar-password" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "system_admin") {
    return <Navigate to="/" replace />;
  }
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/precios" element={<PricingPage />} />
          <Route path="/cambiar-password" element={<ChangePasswordPage />} />
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/buscar" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
          <Route path="/licitacion/:id" element={<ProtectedRoute><TenderDetailPage /></ProtectedRoute>} />
          <Route path="/scraper/config" element={<ProtectedRoute roles={["system_admin","editor"]}><ScraperConfigPage /></ProtectedRoute>} />
          <Route path="/scraper/monitor" element={<ProtectedRoute roles={["system_admin","editor","tech_support"]}><ScraperMonitorPage /></ProtectedRoute>} />
          <Route path="/usuarios" element={<ProtectedRoute roles={["system_admin","client_admin"]}><UsersPage /></ProtectedRoute>} />
          <Route path="/exportar" element={<ProtectedRoute><ExportPage /></ProtectedRoute>} />
          <Route path="/alertas" element={<ProtectedRoute><AlertsPage /></ProtectedRoute>} />
          <Route path="/favoritos" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} />
          <Route path="/perfil" element={<ProtectedRoute><AccountSettingsPage /></ProtectedRoute>} />
          <Route path="/admin/clientes" element={<ProtectedRoute roles={["system_admin"]}><AdminClientsPage /></ProtectedRoute>} />
          <Route path="/proveedores" element={<ProtectedRoute><SuppliersPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
